const Op = {
  // 全匹配
  eq: Symbol.for("eq"),
  // 模糊匹配
  like: Symbol.for("like")
};

export default Op;
